import { Checkbox, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { selectContacts } from 'store/redux-store/placement-client-confirmation-doc-editor/selector';
import { useDispatch, useSelector } from 'react-redux';
import { pConfirmationDocEditorActions } from 'store/redux-store/placement-client-confirmation-doc-editor/slice';
import { missingField } from 'app/constants';
import { useTranslation } from 'react-i18next';
import { CustomTooltip } from '@AMIEWEB/Common';

const useStyles = makeStyles()(theme => ({
  contactsContainer: {
    height: '800px',
    overflowY: 'scroll',
    overflowX: 'hidden',
    maxHeight: 'calc(100vh - 208px)',
    marginTop: '0px',
  },
  listIcon: {
    display: 'flex',
    alignSelf: 'flex-start',
    minWidth: 0,
    marginTop: -4,
  },
  primaryText: {
    fontSize: 14,
    fontWeight: 450,
  },
  secondaryText: {
    fontSize: 14,
    color: theme.palette.system.darkGray,
  },
}));

export const ContactsWrapper = ({ renderPreview }) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  const { editableContacts } = useSelector(selectContacts);

  const dispatch = useDispatch();

  const handleCheckboxChange = (contactId: number) => {
    const updatedContacts = editableContacts.map(contact => {
      return contact.contactId === contactId ? { ...contact, isSelected: !contact.isSelected } : contact;
    });

    dispatch(pConfirmationDocEditorActions.setEditableContacts(updatedContacts));
  };

  return (
    <List classes={{ root: classes.contactsContainer }}>
      {editableContacts.map(({ contactId, email, faxNumber, name, title, isSelected }) => (
        <ListItem key={contactId} disablePadding>
          <ListItemIcon classes={{ root: classes.listIcon }}>
            <CustomTooltip disabled={!renderPreview} tooltipContent={`Disabled on Preview`}>
              <Checkbox
                sx={{
                  color: theme => theme.palette.system.buttonDarkGray,
                  '&.Mui-checked': {
                    color: theme => theme.palette.framework.system.skyBlue,
                  },
                  '&.Mui-disabled': { color: theme => theme.palette.system.buttonDarkGray },
                }}
                edge="start"
                tabIndex={-1}
                disabled={renderPreview}
                disableRipple
                checked={isSelected}
                onClick={() => {
                  handleCheckboxChange(contactId);
                }}
                inputProps={{ 'aria-labelledby': `${contactId}` }}
              />
            </CustomTooltip>
          </ListItemIcon>
          <ListItemText
            primary={name ?? missingField}
            secondary={
              <React.Fragment>
                <Typography variant="body1">{title ? title : `${t('Title')}: ${missingField}`}</Typography>
                <Typography variant="body1">{email ? email : `${t('Email')}: ${missingField}`}</Typography>
                <Typography variant="body1">{`${t('Fax')}: ${faxNumber ? faxNumber : missingField}`}</Typography>
              </React.Fragment>
            }
            classes={{ primary: classes.primaryText, secondary: classes.secondaryText }}
          />
        </ListItem>
      ))}
    </List>
  );
};
